<template>
  <div class="footer" v-if="$route.name != 'Cafe'">
    <div class="footer__social">
      <a href="https://www.instagram.com/espaimovistar" target="_blank">
        <IconBrandInstagram color="#FFFFFF" size="38px" stroke-width="1.2" />
      </a>
      <a href="https://www.facebook.com/MovistarCentre/" target="_blank">
        <IconBrandFacebook color="#FFFFFF" size="38px" stroke-width="1.2" />
      </a>
    </div>
    <div class="footer__options">
      <!-- <div class="footer__menu--off"></div> -->
      <div class="footer__menu">
        <span class="footer__menu--title">{{
          $t('footer.menu.time.title')
        }}</span>
        <ul class="footer__menu__list">
          <li class="footer__menu__list__hour">
            {{ $t('footer.menu.time.hour1') }}
          </li>
          <li class="footer__menu__list__hour">
            {{ $t('footer.menu.time.hour2') }}
          </li>
        </ul>
      </div>
      <div class="footer__menu">
        <span class="footer__menu--title">{{
          $t('footer.menu.address.title')
        }}</span>
        <ul class="footer__menu__list">
          <li class="footer__menu__list--item-no-hover">
            {{ $t('footer.menu.address.location') }}
          </li>
          <li class="footer__menu__list--item-no-hover">
            {{ $t('footer.menu.address.postcode') }}
          </li>
          <li class="footer__menu__list--item pointer">
            <a
              href="https://www.google.com/maps/dir/Current+Location/Pla%C3%A7a%20de%20Catalunya,%2008002%20Barcelona,%20ES/"
              target="_blank"
              >{{ $t('footer.menu.address.maps') }}</a
            >
          </li>
        </ul>
      </div>
      <div class="footer__menu">
        <span class="footer__menu--title">{{
          $t('footer.menu.terms.title')
        }}</span>
        <ul class="footer__menu__list">
          <li class="footer__menu__list--item pointer">
            <a
              href="https://www.movistar.es/atencion-cliente/aviso-legal"
              target="_blank"
              >{{ $t('footer.menu.terms.legal') }}</a
            >
          </li>
          <li class="footer__menu__list--item pointer">
            <a
              href="https://www.movistar.es/atencion-cliente/centro-de-privacidad"
              target="_blank"
              >{{ $t('footer.menu.terms.privacy') }}</a
            >
          </li>
          <li
            class="footer__menu__list--item pointer"
            @click="goToPage('Faqs')"
          >
            {{ $t('footer.menu.terms.faqs') }}
          </li>
        </ul>
      </div>

      <!-- <div class="footer__menu--off"></div> -->
    </div>
    <div class="footer__logo">
      <a href="https://www.telefonica.com/es/" target="_blank">
        <img
          class="footer__logo--img"
          src="/img/logo_telefonica_convencional.png"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
  import router from '@/router'
  import {
    IconBrandFacebook,
    IconBrandInstagram,
    IconBrandYoutube,
    IconMapPin,
    IconPhone
  } from '@tabler/icons-vue'

  const goToPage = (url) => {
    router.push({ name: url })
  }
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .footer {
    display: grid;
    grid-template-rows: auto;
    background: rgb(0, 102, 255);
    //background: rgb(1, 157, 244);
    //background: linear-gradient(
    //  45deg,
    //  rgba(1, 157, 244, 1) -5%,
    //  rgba(11, 39, 57, 1) 50%
    //);

    &__social {
      @include d-flex(row, center, center, 20px);
      padding: 20px;
      width: 100%;
      cursor: pointer;
    }
    &__options {
      border-top: 1px solid #86888c;
      @media screen and (min-width: $sm-breakpoint) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        padding: 30px 15px;
        gap: 50px;
      }
      @media screen and (min-width: $md-breakpoint) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
      }
      @media screen and (min-width: $lg-breakpoint) {
        @include d-flex(row, center, initial, 50px);
        padding: 30px 15px;
      }
    }
    &__menu {
      @include d-flex(column, initial, initial, 15px);
      &--title {
        font-weight: 600;
        color: #fff;
      }
      &__list {
        @include d-flex(column, initial, initial, 5px);
        &__hour {
          @include d-flex(row, initial, initial, 10px);
          color: #fff;
        }
        &--item {
          @include d-flex(row, initial, center, 5px);
          color: #fff;
          font-family: 'OnAir-text-bold';
          &:hover {
            cursor: pointer;
            font-family: 'OnAir-text-black';
            color: var(--primary-40-color);
          }
        }
        &--item-no-hover {
          @include d-flex(row, initial, center, 5px);
          color: #fff;
        }
      }
    }
    &__logo {
      @include d-flex(row, center, center);
      padding: 20px;
      &--img {
        width: 125px;
        height: auto;
      }
    }
    @media screen and (max-width: $sm-breakpoint) {
      display: none;
    }
    @media screen and (min-width: $sm-breakpoint) {
      padding: 20px 0px;
    }
    @media screen and (min-width: $md-breakpoint) {
      padding: 20px 50px;
    }
    @media screen and (min-width: $lg-breakpoint) {
      padding: 20px 100px;
    }
  }
</style>
